import { useCallback, useState } from 'react';
import { validateObservationFile } from './observationFileUtils';

let pendingFileId = 0;

const createPendingId = () => {
  pendingFileId += 1;
  return `pending-${pendingFileId}`;
};

const usePendingObservationFiles = ({ onError } = {}) => {
  const [pendingFiles, setPendingFiles] = useState([]);

  const setError = (message) => {
    if (message) onError?.(message);
  };

  const addFile = useCallback((file) => {
    const validationError = validateObservationFile(file);
    if (validationError) {
      setError(validationError);
      return false;
    }

    setPendingFiles((prev) => [
      ...prev,
      {
        id: createPendingId(),
        file,
        categories: []
      }
    ]);
    return true;
  }, [onError]);

  const removeFile = useCallback((pendingId) => {
    setPendingFiles((prev) => prev.filter((item) => item.id !== pendingId));
  }, []);

  const toggleCategory = useCallback((pendingId, categoryAlias) => {
    setPendingFiles((prev) => prev.map((item) => {
      if (item.id !== pendingId) return item;

      const categories = item.categories.includes(categoryAlias)
        ? item.categories.filter((alias) => alias !== categoryAlias)
        : [...item.categories, categoryAlias];

      return { ...item, categories };
    }));
  }, []);

  const clearPendingFiles = useCallback(() => {
    setPendingFiles([]);
  }, []);

  const validatePendingFiles = useCallback(() => {
    if (!pendingFiles.length) return true;

    const missingCategories = pendingFiles.some((item) => item.categories.length === 0);
    if (missingCategories) {
      setError('Seleccioná al menos una categoría para cada archivo adjunto.');
      return false;
    }

    return true;
  }, [pendingFiles, onError]);

  return {
    pendingFiles,
    addFile,
    removeFile,
    toggleCategory,
    clearPendingFiles,
    validatePendingFiles
  };
};

export default usePendingObservationFiles;
